import React, { useState } from "react"
import { FormControlLabel, Grid, Switch } from "@mui/material"
import Tick from "../../assets/icons/tick.svg"
import Close from "../../assets/icons/close.svg"

import * as S from "./copia-app-features.styles"

const CopiaAppFeatures = ({ title, features, image }) => {
  const [checked, setChecked] = useState(false)

  return (
    <S.Section>
      <S.Wrapper maxWidth="xl">
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <S.InfoContainer>
              <S.Title>{title}</S.Title>
              <S.SwitchContainer>
                <FormControlLabel
                  control={
                    <Switch
                      checked={checked}
                      onChange={() => setChecked(!checked)}
                      className={checked ? "bg-color" : ""}
                    />
                  }
                  label={checked ? "SUBSCRIPTION" : "COPIA APP"}
                  labelPlacement="start"
                />
              </S.SwitchContainer>
              <S.CustomGridContainer container spacing={0}>
                {features?.map(({ description, check }, index) => (
                  <Grid item xs={12} md={6} key={`${description}-${index}`}>
                    <S.FeatureContainer>
                      <S.Description className="feature">
                        {description}
                      </S.Description>
                      {check || checked ? <Tick /> : <Close />}
                    </S.FeatureContainer>
                  </Grid>
                ))}
              </S.CustomGridContainer>
            </S.InfoContainer>
          </Grid>
          <Grid item xs={12} md={6}>
            <S.Image img={image} />
          </Grid>
        </Grid>
      </S.Wrapper>
    </S.Section>
  )
}

export default CopiaAppFeatures
